import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import MinuteEndcardEditor from "@/components/MinuteEndcardEditor";

const DEFAULT_EC = {
  enabled: false,
  line1: "",
  line2: "",
  line3: "",
  font_size: "medium",
  text_color: "#ffffff",
  bg_color: "#1a2818",
  domain: "",
  logo_image: null,
  logo_image_id: null,
  qr_image: null,
  qr_image_id: null,
  show_branding: true,
};

// Self-contained end-card configurator for the standard (Generate/DIY) video flow.
// Loads the manual's saved end card, renders the shared editor, and debounce-saves to the backend.
export const EndCardStudio = ({ manualId, orientation = "landscape", initial }) => {
  const [ec, setEc] = useState({ ...DEFAULT_EC, ...(initial || {}) });
  const timer = useRef(null);
  const dirty = useRef(false);

  const save = async (next) => {
    try {
      const { data } = await api.post(`/manuals/${manualId}/endcard`, next);
      const doc = data?.endcard;
      // Swap freshly-uploaded base64 for the stored image ids so we stop re-uploading them on every
      // keystroke (and the preview loads from the server copy).
      if (doc && (doc.logo_image_id || doc.qr_image_id)) {
        setEc((cur) => ({
          ...cur,
          logo_image: cur.logo_image ? null : cur.logo_image,
          logo_image_id: doc.logo_image_id || cur.logo_image_id,
          qr_image: cur.qr_image ? null : cur.qr_image,
          qr_image_id: doc.qr_image_id || cur.qr_image_id,
        }));
      }
    } catch {
      toast.error("Couldn't save your end card — please try again");
    }
  };

  const onChange = (next) => {
    dirty.current = true;
    setEc(next);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => save(next), 800);
  };

  // Flush a pending save when leaving the page.
  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
      if (dirty.current) save(ec);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ec]);

  return (
    <div data-testid="endcard-studio">
      <MinuteEndcardEditor value={ec} onChange={onChange} orientation={orientation} />
      <p className="text-[11px] text-center mt-3" style={{ color: "#8f88ad" }} data-testid="endcard-replace-note">
        When ON, your card fully replaces the Vittyyo closing card and the site URL is removed from your video — the small stairs mark stays in the corner.
      </p>
    </div>
  );
};

export default EndCardStudio;
